var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewnow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.08366 0.75C2.44604 0.75 1.91699 1.27905 1.91699 1.91667V3.66667L0.166992 5.41667H3.08366H10.667C11.3046 5.41667 11.8337 4.88762 11.8337 4.25V1.91667C11.8337 1.27905 11.3046 0.75 10.667 0.75H3.08366ZM3.08366 1.91667H10.667V4.25H3.08366V1.91667ZM3.08366 6.58333C2.44604 6.58333 1.91699 7.11238 1.91699 7.75V9.5L0.166992 11.25H3.08366H10.667C11.3046 11.25 11.8337 10.721 11.8337 10.0833V7.75C11.8337 7.11238 11.3046 6.58333 10.667 6.58333H3.08366ZM3.08366 7.75H10.667V10.0833H3.08366V8.33333V7.75Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewnow);
export default __webpack_public_path__ + "static/media/viewnow.a86f82c595b3985cd2f0422ece71f0f7.svg";
export { ForwardRef as ReactComponent };